function getContactForm(eventTarget) {
  if (!eventTarget) {
    return null;
  }

  if (eventTarget.matches && eventTarget.matches('.wpcf7-form')) {
    return eventTarget;
  }

  if (eventTarget.querySelector) {
    const form = eventTarget.querySelector('.wpcf7-form');

    if (form) {
      return form;
    }
  }

  return eventTarget.closest ? eventTarget.closest('.wpcf7-form') : null;
}

function removeValidationTips(form) {
  form.querySelectorAll('.wpcf7-not-valid-tip').forEach((tip) => {
    tip.remove();
  });
}

function setSubmitDisabled(form, disabled) {
  form.querySelectorAll('[type="submit"], .wpcf7-submit').forEach((button) => {
    button.disabled = disabled;
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  });

  form.setAttribute('aria-busy', disabled ? 'true' : 'false');
}

function ContactForm7Safeguard() {
  document.addEventListener('submit', (event) => {
    const form = getContactForm(event.target);

    if (!form) {
      return;
    }

    removeValidationTips(form);
    setSubmitDisabled(form, true);
  }, true);

  [
    'wpcf7invalid',
    'wpcf7mailsent',
    'wpcf7mailfailed',
    'wpcf7spam',
    'wpcf7submit',
  ].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const form = getContactForm(event.target);

      if (!form) {
        return;
      }

      setSubmitDisabled(form, false);
    });
  });
}

export default ContactForm7Safeguard;
